const mapGroupToOptions = (groups) => groups.map(({ id, name }) => ({ label: capitalize(name), value: id }));

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export default mapGroupToOptions;
